import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


// ** Fetch Users
export const fetchTemplates = createAsyncThunk(
    "fetchTemplates",
    async (params,config) => {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL_LOCAL}/api/templates/fetchAll`,
            params
        );

        return response.data;
    }
);

export const createTemplates= createAsyncThunk(
    "createTemplates",
    async (data) => {

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL_LOCAL}/api/templates/create`,
            data
        );

        return response.data;
    }
);
export const templateSlice = createSlice({
    name: "template",
    initialState: {
        templates: "",
        total: 0,
        limit: 10,
        page: 1,
        pageCount:0,
        isLoading: true,
    },
    reducers: {
        changeLimit: (state, action) => {
            state.limit = action.payload;
        },
        changePage: (state, action) => {
            state.page = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTemplates.fulfilled, (state, action) => {
            state.templates = action?.payload?.data?.templates
            state.total = action?.payload?.data?.totalCount
            state.page = action?.payload?.data?.currentPage
            state.pageCount = action?.payload?.data?.totalPages
         
            state.isLoading = true;
            if (action?.payload?.code === 200) {
                state.users = action.payload?.body.users;
                state.total = action.payload?.body.total;
                state.isLoading = false;
            }
        })

    },
});

export const { changeLimit, changePage } = templateSlice.actions;
export default templateSlice.reducer;
